import Vue from 'vue';
import _unescape from 'lodash/unescape';
import _truncate from 'lodash/truncate';
import {abbrNum, formatKeyword, thousandSeperator} from "./utils";
import {fromUnicodeToZawgyi} from "./utils/font";

Vue.filter("statusFilter", function(status, cases) {
	return cases[status];
});

//Thousand separator filter
Vue.filter("formatNumber", function(raw){
	return thousandSeperator(raw);
});

//Abbr Number with k,m
Vue.filter("abbrNumber", function(raw){
	return abbrNum(raw, 2);
});

// Remove '|' from keyword
Vue.filter("formatKeyword", function(keyword){
	return formatKeyword(keyword);
});

//&amp;, &lt;, &gt;, &quot;, and &#39; in string to their corresponding characters
Vue.filter("unescapeString", function(raw){
	return _unescape(raw);
});

Vue.filter("truncateString", function(raw){
	return _truncate(raw, {length: 30});
});

Vue.filter("highlightPost", function (text, keyword) {
	let keywords = keyword.map(keyword => {
		let matchKeyword = keyword.includes("|") ? keyword.split("|")[0] : keyword;
		matchKeyword = fromUnicodeToZawgyi(matchKeyword);
		return new RegExp(`(${matchKeyword})`, 'ig');
	});
	if (text) {
		text = fromUnicodeToZawgyi(text);
		keywords.forEach((keyword) => text = text.replace(keyword, '<h>$1</h>'));
		text = text.replace(/<h>(.*?)<h>(.*?)<\/h>(.*)<\/h>/g, '<h>$1$2$3</h>');
		text = text.replace(/<h>/g, "<strong style='color:var(--bindez-green-color);'>");
		text = text.replace(/<\/h>/g, "</strong>");
	}
	return text
});

Vue.filter("fromUnicodeToZawgyi", function(str){
	return fromUnicodeToZawgyi(str);
});
